import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { UnderlinedHeader } from '@components/typographies';

import * as styles from './Header.module.scss';

export const Header: React.FC = () => {
	return (
		<PaddingContainer
			className={classNames(styles.wrapper, 'white-bg relative')}
		>
			<WidthContainer className={styles.container}>
				<UnderlinedHeader subtitle="Design. From concept to the final product. ">
					UX/UI Design
				</UnderlinedHeader>
			</WidthContainer>
		</PaddingContainer>
	);
};
